
angular.module('qkr.inventory').config(['$routeSegmentProvider', '$routeProvider', 'appUrl',
    function($routeSegmentProvider, $routeProvider, appUrl) {
        $routeSegmentProvider.options.autoLoadTemplates = true;

        $routeSegmentProvider.
            when('/inventory', 'inventory', { pageTitle: 'Products'} ).
            when('/inventoryItem/edit/:id', 'inventoryItemEdit', { pageTitle: 'Edit Product'}).
            when('/inventoryItem/clone/:id', 'inventoryItemClone').
            when('/inventoryItem/create', 'inventoryItemCreate', { pageTitle: 'New Product' }).
            when('/inventoryItem/create/:productName', 'inventoryItemCreate');

        $routeSegmentProvider
            .segment('inventory', {
                controller: 'inventoryController',
                template: require('../../inventory/templates/inventory.html'),
                resolve: {
                    products(inventoryService) {
                        'ngInject';
                        return inventoryService.loadInventory(true);
                    },
                    categories(inventoryService) {
                        'ngInject';
                        return inventoryService.loadProductCategoriesForInventory();
                    }
                }
            })
            .segment('inventoryItemEdit', {
                controller: 'InventoryItemController',
                dependencies: ['id'],
                template: require('../../inventory/templates/inventoryItem.html'),
                resolve: {
                    inventoryItemInitData(inventoryItemService) {
                        'ngInject';
                        return inventoryItemService.resolve(false, false, null);
                    }
                }
            })
            .segment('inventoryItemClone', {
                controller: 'InventoryItemController',
                dependencies: ['id'],
                template: require('../../inventory/templates/inventoryItem.html'),
                resolve: {
                    inventoryItemInitData(inventoryItemService) {
                        'ngInject';
                        return inventoryItemService.resolve(true, true, null);
                    }
                }
            })
            .segment('inventoryItemCreate', {
                controller: 'InventoryItemController',
             template: require('../../inventory/templates/inventoryItem.html'),
                dependencies: ['productName'],
                resolve: {
                    inventoryItemInitData($routeParams, inventoryItemService) {
                        'ngInject';
                        return inventoryItemService.resolve(true, false, $routeParams.productName);
                    }
                }
            });

        $routeProvider.otherwise({
            redirectTo: appUrl.pageLanding
        });
}]);



// WEBPACK FOOTER //
// ./src/inventory/config/inventory.config.js